module.exports = __webpack_public_path__ + "img/anastasiya_smolygina-min.eab20ccc.jpg";